import React from "react";

import Layout from "../components/Layout";
import SEO from "../components/seo";
import RittalCatalogBanner from "../components/RittalCatalogBanner";

import pic1 from "../assets/images/cmo_logo.jpg";
import pic2 from "../assets/images/aeg_logo.png";
import pic3 from "../assets/images/yatagan_logo.png";
import pic4 from "../assets/images/rittal_logo.png";
import logo from "../assets/img/logo.png";

import { Link } from "gatsby";

const IndexPage = () => (
  <Layout>
    <SEO />
    <div id="main">
      <div className="inner">
        <header>
          <h1>
            Расширенные возможности <span className="name">Automatisierte Maschinenbau Gruppe</span>
          </h1>
        </header>
        <section className="tiles">
          <article className="style1">
            <span className="image">
              <img src={pic1} alt="" />
            </span>
            <Link to="/catalog/cmo/catalog">
              <h2>Телекоммуникационное оборудование ЦМО</h2>
              <div className="content">
                <p>
                  Поставка телекоммуникационных и электротехнических корпусов
                </p>
              </div>
            </Link>
          </article>
          <article className="style1">
            <span className="image">
              <img src={pic2} alt="AEG Power solutions" />
            </span>
            <Link to="/catalog/aeg/catalog">
              <h2>AEG Power Solutions</h2>
              <div className="content">
                <p>

                </p>
              </div>
            </Link>
          </article>
          <article className="style1">
            <span className="image">
              <img src={pic3} alt="Ятаган" />
            </span>
            <Link to="/catalog/yatagan/catalog">
              <h2>Воздухоочистное оборудование Ятаган</h2>
              <div className="content">
                <p>
                  Комплексное решение задачи очистки воздуха
                </p>
              </div>
            </Link>
          </article>
          <article className="style1 store">
            <span className="image">
              <img src={logo} alt="Интернет-магазин AMG Distribution" />
            </span>
            <a href="//distribution.amgcorporation.de/shop">
              <h2>Интернет-магазин</h2>
              <div className="content">
                <p>
                  Онлайн-магазин электротехнической продукции <nobr>AMG Distribution</nobr>
                </p>
              </div>
            </a>
          </article>
          <article className="style1 rittal rittal_link">
            <span className="image">
              <img src={pic4} alt="Оборудование Rittal со склада в России" />
            </span>
            <a href="//distribution.amgcorporation.de/shop/">
              <h2>Rittal со склада в России</h2>
              <div className="content">
                <p>

                </p>
              </div>
            </a>
          </article>
          <article className="style1 rittal rittal_description" style={{maxHeight: 'none'}}>
            <RittalCatalogBanner />
          </article>
          {/* <article className="style3">
            <span className="image">
              <img src={pic3} alt="" />
            </span>
            <Link to="/Generic">
              <h2>Feugiat</h2>
              <div className="content">
                <p>
                  Sed nisl arcu euismod sit amet nisi lorem etiam dolor veroeros
                  et feugiat.
                </p>
              </div>
            </Link>
          </article>
          <article className="style4">
            <span className="image">
              <img src={pic4} alt="" />
            </span>
            <Link to="/Generic">
              <h2>Tempus</h2>
              <div className="content">
                <p>
                  Sed nisl arcu euismod sit amet nisi lorem etiam dolor veroeros
                  et feugiat.
                </p>
              </div>
            </Link>
          </article>
          <article className="style5">
            <span className="image">
              <img src={pic5} alt="" />
            </span>
            <Link to="/Generic">
              <h2>Aliquam</h2>
              <div className="content">
                <p>
                  Sed nisl arcu euismod sit amet nisi lorem etiam dolor veroeros
                  et feugiat.
                </p>
              </div>
            </Link>
          </article>
          <article className="style6">
            <span className="image">
              <img src={pic6} alt="" />
            </span>
            <Link to="/Generic">
              <h2>Veroeros</h2>
              <div className="content">
                <p>
                  Sed nisl arcu euismod sit amet nisi lorem etiam dolor veroeros
                  et feugiat.
                </p>
              </div>
            </Link>
          </article>
          <article className="style2">
            <span className="image">
              <img src={pic1} alt="" />
            </span>
            <Link to="/Generic">
              <h2>Ipsum</h2>
              <div className="content">
                <p>
                  Sed nisl arcu euismod sit amet nisi lorem etiam dolor veroeros
                  et feugiat.
                </p>
              </div>
            </Link>
          </article>
          <article className="style3">
            <span className="image">
              <img src={pic2} alt="" />
            </span>
            <Link to="/Generic">
              <h2>Dolor</h2>
              <div className="content">
                <p>
                  Sed nisl arcu euismod sit amet nisi lorem etiam dolor veroeros
                  et feugiat.
                </p>
              </div>
            </Link>
          </article>
          <article className="style1">
            <span className="image">
              <img src={pic3} alt="" />
            </span>
            <Link to="/Generic">
              <h2>Nullam</h2>
              <div className="content">
                <p>
                  Sed nisl arcu euismod sit amet nisi lorem etiam dolor veroeros
                  et feugiat.
                </p>
              </div>
            </Link>
          </article>
          <article className="style5">
            <span className="image">
              <img src={pic4} alt="" />
            </span>
            <Link to="/Generic">
              <h2>Ultricies</h2>
              <div className="content">
                <p>
                  Sed nisl arcu euismod sit amet nisi lorem etiam dolor veroeros
                  et feugiat.
                </p>
              </div>
            </Link>
          </article>
          <article className="style6">
            <span className="image">
              <img src={pic5} alt="" />
            </span>
            <Link to="/Generic">
              <h2>Dictum</h2>
              <div className="content">
                <p>
                  Sed nisl arcu euismod sit amet nisi lorem etiam dolor veroeros
                  et feugiat.
                </p>
              </div>
            </Link>
          </article>
          <article className="style4">
            <span className="image">
              <img src={pic6} alt="" />
            </span>
            <Link to="/Generic">
              <h2>Pretium</h2>
              <div className="content">
                <p>
                  Sed nisl arcu euismod sit amet nisi lorem etiam dolor veroeros
                  et feugiat.
                </p>
              </div>
            </Link>
          </article> */}
        </section>
      </div>
    </div>
  </Layout>
);

export default IndexPage;
